import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

export default function useActionNotificationStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = useTheme();
  const actionNameStyle = {
    color: colorStyle.color.primary,
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '400',
  };
  const iconColor = colorStyle.color.secondary;
  return { actionNameStyle, iconColor };
}

export function useApplyBoundStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const iconColor = colorStyle.color.secondary;
  return { iconColor };
}
